<div class="flex justify-between py-3 border-b">
	<div>{{ key | translate }}</div>
	<div class="flex items-center font-bold">
		<ng-content></ng-content>
	</div>
</div>
